import { PageConfType } from 'base/utils/parse-app-context';

export const pages: Record<string, Partial<PageConfType>> = {
    index: {
        viewType: 'index',
        seoCode: 'index',
        i18nNamespace: 'home'
    },
    list: {
        viewType: 'list',
        seoCode: 'list',
        queryKeys: ['p', 'order', 'topp', 'topv'],
        i18nNamespace: 'list',
    },
    search: {
        viewType: 'search',
        seoCode: 'list',
        queryKeys: ['q', 'p', 'order', 'topp', 'topv'],
        i18nNamespace: 'list',
    },
    diyPool: {
        viewType: 'diy_pool',
        seoCode: 'DIY_POOLS',
        i18nNamespace: 'diyPool',
    },
    detail: {
        viewType: 'detail',
        seoCode: 'detail',
        i18nNamespace: 'detail',
    },
    cart: {
        viewType: 'cart',
        i18nNamespace: 'cart',
    },
    checkout: {
        viewType: 'checkout',
        needAuth: ['checkoutId'],
        i18nNamespace: 'checkout',
    },
    pay: {
        viewType: 'card',
        i18nNamespace: 'pay',
    },
    purchase: {
        viewType: 'purchase',
        queryKeys: ['success'],
        i18nNamespace: 'purchase',
    },
    login: {
        viewType: 'customers/login',
        i18nNamespace: 'login',
    },
    account: {
        viewType: 'customers/account',
        needAuth: true,
        i18nNamespace: 'account',
    },
    profile: {
        viewType: 'customers/profile',
        needAuth: true,
        i18nNamespace: 'profile',
    },
    address: {
        viewType: 'customers/address',
        needAuth: true,
        i18nNamespace: 'address',
    },
    orders: {
        viewType: 'customers/orders',
        needAuth: true,
        i18nNamespace: 'orders',
    },
    order: {
        viewType: 'customers/order',
        needAuth: true,
        i18nNamespace: 'order',
    },
    review: {
        viewType: 'customers/order_review',
        needAuth: true,
        i18nNamespace: 'review',
    },
    refund: {
        viewType: 'refund',
        needAuth: true,
        i18nNamespace: 'refund',
    },
    packages: {
        viewType: 'customers/packages',
        needAuth: true,
        i18nNamespace: 'packages',
    },
    track: {
        viewType: 'customers/track',
        needAuth: true,
        i18nNamespace: 'track',
    },
    coupons: {
        viewType: 'customers/coupons',
        needAuth: true,
        i18nNamespace: 'coupons',
    },
    points: {
        viewType: 'customers/points',
        detail: 'history',
        needAuth: true,
        i18nNamespace: 'points',
    },
    pointsMarketplace: {
        viewType: 'customers/points',
        detail: 'pointsMarketplace',
        seoCode: 'pointsMarketplace',
        needAuth: true,
        i18nNamespace: 'pointsMarketplace',
    },
    messageCenter: {
        viewType: 'customers/message_center',
        needAuth: true,
        i18nNamespace: 'messageCenter',
    },
    security: {
        viewType: 'password',
        needAuth: true,
        i18nNamespace: 'security',
    },
    changeEmail: {
        viewType: 'customers/change_email',
    },
    resetPassword: {
        viewType: 'customers/reset_password',
        i18nNamespace: 'resetPassword',
    },
    settings: {
        viewType: 'customers/other',
        detail: 'settings',
        seoCode: 'settings',
    },
    locale: {
        viewType: 'customers/other',
        detail: 'locale',
        seoCode: 'locale',
    },
    help: {
        viewType: 'help',
        i18nNamespace: 'help',
    },
    helpCenter: {
        viewType: 'help_center',
        i18nNamespace: 'helpCenter',
    },
    weeklyDeal: {
        viewType: 'marketing',
        seoCode: 'weeklyDeal',
        i18nNamespace: 'weeklyDeal',
    },
    blackFriday: {
        viewType: 'marketing',
        seoCode: 'blackFriday',
        i18nNamespace: 'blackFriday',
    },
    smartGrowSystem: {
        viewType: 'marketing',
        seoCode: 'smartGrowSystem',
        i18nNamespace: 'smartGrowSystem',
    },
    technicalGuide: {
        viewType: 'technical_guide',
        i18nNamespace: 'technicalGuide',
    },
    guides: {
        viewType: 'guides',
        i18nNamespace: 'guides',
    },
    supportGuide: {
        viewType: 'guides',
        i18nNamespace: 'supportGuide',
        seoCode: 'supportGuide',
    },
    brochure: {
        viewType: 'brochure',
        seoCode: 'brochure',
        i18nNamespace: 'brochure',
    },
    terplux: {
        viewType: 'brochure',
        seoCode: 'terplux',
        i18nNamespace: 'terplux',
    },
    blackFridayCheckIn: {
        viewType: 'activity',
        i18nNamespace: 'blackFridayCheckIn',
    },
    winterSurprise: {
        viewType: 'activity',
        detail: 'winterSurprise',
        seoCode: 'winterSurprise',
        i18nNamespace: 'winterSurprise',
    },
    testerClub: {
        viewType: 'activity',
        detail: 'testerClub',
        seoCode: 'testerClub',
        i18nNamespace: 'testerClub',
    },
    superSlots: {
        viewType: 'activity',
        detail: 'superSlots',
        seoCode: 'superSlots',
        i18nNamespace: 'superSlots',
    },
    vgrowGrowingChallenge: {
        viewType: 'activity',
        detail: 'vgrowGrowingChallenge',
        seoCode: 'vgrowGrowingChallenge',
        i18nNamespace: 'vgrowGrowingChallenge',
    },
    referral: {
        viewType: 'marketing',
        detail: 'referral',
        seoCode: 'referral',
        i18nNamespace: 'referral',
    },
    referAFriend: {
        viewType: 'customers/other',
        detail: 'refer_a_friend',
        seoCode: 'referAFriend',
        needAuth: true,
        i18nNamespace: 'referAFriend',
    },
    becomeAReseller: {
        viewType: 'customers/other',
        seoCode: 'becomeAReseller',
    },
    ageGate: {
        i18nNamespace: 'ageGate',
    },
    redeemRewards: {
        viewType: 'activity',
        detail: 'redeemRewards',
        seoCode: 'redeemRewards',
    },
    yearReview2024: {
        viewType: 'marketing',
        detail: 'yearReview2024',
        seoCode: 'yearReview2024',
    },
    '420CheckIn': {
        viewType: 'marketing',
        detail: '420CheckIn',
        seoCode: '420CheckIn',
    },
    crowdFunding: {
        viewType: 'activity',
        detail: 'crowdFunding',
        seoCode: 'crowdFunding',
    },
};